import React, { FC, Fragment, useState } from 'react';
import { IconButton } from '@material-ui/core';
import { createStyles, withStyles, darken, Theme, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { ShareDialog } from 'features/sharing';
import { CustomSVG } from 'components';
import { useContent } from 'hooks';

interface IProps extends WithStyles<typeof styles> {
  size: 'small' | 'regular';
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: darken(theme.palette.secondary.main, 0.1),
      },
    },
    hasShared: {
      backgroundColor: theme.custom.palette.grey1,
    },
    small: {
      padding: theme.spacing(0.5),
    },
    regular: {
      padding: theme.spacing(1),
    },
  });

const ShareButton: FC<IProps> = ({ classes, size }) => {
  const [open, setOpen] = useState(false);
  const content = useContent();

  const iconSize = size === 'small' ? 16 : 32;
  const buttonClasses = classNames(classes.button, classes[size], {
    [classes.hasShared]: content && content.has_requesting_user_shared,
  });

  function handleOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <Fragment>
      <IconButton className={buttonClasses} onClick={handleOpen}>
        <CustomSVG name="arrow" size={iconSize} />
      </IconButton>
      <ShareDialog onClose={handleClose} open={open} />
    </Fragment>
  );
};

export default withStyles(styles)(ShareButton);
